//
// Manages floating ads.
function AdsNinjaFloatingPosition(){}

AdsNinjaFloatingPosition.prototype = Object.create(AdsNinjaFloatingStrategy.prototype);

// TODO: Implement.

window.AdsNinjaFloatingPosition = AdsNinjaFloatingPosition;